<template lang="html">
  <modal
    name="edit-vendor-modal"
    height="auto" width="416"
    :adaptive="true"
    :maxWidth="416"
    class="edit-vendor-modal"
    @before-open="beforeOpen"
  >
    <div class="modal-container">
      <div class="modal-header">
        {{headerText}}
      </div>
      <div class="line-break">

      </div>
      <div class="modal-body">
        <div class="bold">Name</div>
        <div class="gap-1x"></div>
        <InputWithErrorV2
          v-bind:value.sync="vendor.name"
          placeholder="Vendor Name"
        />
        <div class="gap-3x"></div>
        <div class="bold">Type</div>
        <div class="gap-1x"></div>
        <select class="select input" v-model="vendor.type">
          <option hidden disabled selected value="null" v-if="!vendor.type">Select one</option>
          <option v-for="option in types" :value="option" :key="option">{{option}}</option>
        </select>
        <div class="gap-3x"></div>
        <div class="bold">Contact</div>
        <div class="gap-2x"></div>
        <div class="bold">Email</div>
        <InputWithErrorV2
          v-bind:value.sync="vendor.email"
          placeholder="Vendor Contact Email"
        />
        <div class="gap-2x"></div>
        <div class="bold">First Name</div>
        <InputWithErrorV2
          v-bind:value.sync="vendor.first_name"
          placeholder="Vendor Contact First Name"
        />
        <div class="gap-2x"></div>
        <div class="bold">Last Name</div>
        <InputWithErrorV2
          v-bind:value.sync="vendor.last_name"
          placeholder="Vendor Contact Last Name"
        />
        <div class="gap-2x"></div>
        <div class="bold">Phone</div>
        <InputWithErrorV2
          v-bind:value.sync="vendor.phone"
          placeholder="Vendor Contact Phone"
        />
        <div class="gap-3x"></div>
      </div>
      <div class="line-break" />
      <ModalFooter
        :save="save"
        :cancel="() => $modal.hide('edit-vendor-modal')"
        :rightActionLoading="loading"
      />
    </div>
  </modal>
</template>

<script>
import ModalFooter from 'src/components/common/modals/shares/ModalFooter.vue'
import InputWithErrorV2 from 'src/components/common/InputWithErrorV2.vue'

export default {
  components: { ModalFooter, InputWithErrorV2 },
  data() {
    return {
      vendor: {},
      loading: false,
      types: ['business', 'government'],
    }
  },
  methods: {
    save() {
      this.loading = true;
      if (this.vendor.ID) {
        this.$vendor.updateVendor(this.vendor, this.afterUpdate, this.updateErrorHandler)
      } else {
        this.$vendor.createVendor(this.vendor, this.afterUpdate, this.updateErrorHandler)
      }
    },
    beforeOpen(event) {
      this.vendor = event.params.vendor || {};
    },
    afterUpdate() {
      this.loading = false
      this.$emit('updated-vendors')
      this.$modal.hide('edit-vendor-modal')
    },
    updateErrorHandler() {
      this.loading = false
      alert("Something went wrong, please try again!")
    }
  },
  computed: {
    headerText() {
      return this.vendor.ID ? `Edit Vendor` : 'New Vendor'
    }
  }
}
</script>

<style lang="scss">
.modal-body {
  min-height: auto !important;

  input, select {
    width: 100%;
  }
}
</style>
